function initAjaxList() {
  if ($('#ajax-list-posts').length == 0) {
    return false;
  }

  const container = $('#ajax-list-container');
  const dropdown_item = $('.dropdown-item');
  const ajax_paginate = $('#ajax-list-paginate');
  const ajax_posts = $('#ajax-list-posts');
  const ajax_error = $('#ajax-list-error');
  const ajax_counter = $('#ajax-list-count');
  const ajax_nav_bottom = $('#ajax-nav-bottom');
  const dropdown_prefix = 'ajax-list-dropdown-';
  const compare_button = $('#btn-compare-selections');
  const clear_compare_button = $('#btn-clear-compare-selections');
  const ajax_list_reset = $('#ajax-list-reset');
  const nav_bottom = $('#ajax-list-nav-hide');
  const taxonomies_slugs = fpm001_ajax_list.taxonomies_slugs;
  let paged = 1;

  clear_compare_button.on('click', function () {
    $('.compare-checkbox').removeAttr('checked');
    sessionStorage.removeItem('compare');
    showCompareButton();
  });

  $('.ajax-list-type input[type="radio"]').on('change', function () {
    ajax_posts.attr('data-type', $(this).val());
  });

  $('.filter-tooltip span').on('click', function () {
    const tooltipId = $(this).data('index');
    $('#' + tooltipId).toggleClass('show');
    const list = $(this).closest('.terms-list');
    list.find('.filter-title').toggleClass('d-none');
    list.find('.term-list-filters').toggleClass('hidden');
  });

  nav_bottom.find('.ajax-list-nav-bottom-title').on('click', function () {
    const filters = $(this).parent();
    filters.toggleClass('show');
    if (filters.hasClass('show')) {
      $(this).text(fpm001_localize.hide_filters);
    } else {
      $(this).text(fpm001_localize.show_filters);
    }
  });

  $(document).ready(function () {
    // Disable this for now
    /*if (window.location.href.indexOf('?') == -1) {
      nav_bottom
        .addClass('show')
        .find('.ajax-list-nav-bottom-title')
        .text(fpm001_localize.hide_filters);
    }*/

    checkURLParams();
  });

  $(document).on('click', '.ajax-list-paginate a', function (event) {
    event.preventDefault();
    scrollToTop();
    const current = $(event.currentTarget);
    const href = current.attr('href');
    const url = new URL(href);
    const urlParams = new URLSearchParams(url.search);
    const current_paged = urlParams.get('paged');
    storePaged(current_paged);
    setPaged(current_paged);
    changeURL();
    getPosts();
  });

  ajax_list_reset.on('click', function (e) {
    e.preventDefault();

    resetSidebar();
  });

  dropdown_item.on('click', function (e) {
    e.preventDefault();
    const $this = $(this);
    const label = $this.text();
    const value = $this.data('value');
    const dropdown_label = getDropDownLabel($this);

    setPaged(1);
    storePaged(1);
    setDropdownValue(label, value, dropdown_label);
    storeDropdownValue($this);
    changeURL();
    getPosts();
  });

  //Reset filters before leaving the page
  window.onbeforeunload = function () {
    clearStorage();
  };

  function resetSidebar() {
    $('.terms-list input:checked').removeAttr('checked');
    clearStorage();
    setPaged(1);
    storePaged(1);
    const origin = window.location.origin;
    const pathname = window.location.pathname;
    history.pushState(null, null, origin + pathname);
    getPosts();
  }

  $('.terms-list input[type="checkbox"], .terms-list input[type="radio"]').on('change', function () {
    storeTerms();
    setPaged(1);
    storePaged(1);
    changeURL();
    getPosts();
  });

  $(document).on('term-selected', function (e, id) {
    $(id).prop('checked', true);
    storeTerms();
    getPosts();
  });

  ajax_posts.on('change', '.compare-checkbox', function () {
    const value = $(this).val();
    updateCompareList(value);
  });

  function checkURLParams() {
    const params = new URLSearchParams(window.location.search);
    const url_values = Object.fromEntries(params);

    if (url_values['paged'] !== undefined) {
      storePaged(url_values['paged']);
    }

    if (url_values['effort-label'] !== undefined && url_values['effort-value'] !== undefined) {
      storeDropdownValue(null, url_values['effort-value'], url_values['effort-label'], 'effort');
    }

    if (url_values['cost-label'] !== undefined && url_values['cost-value'] !== undefined) {
      storeDropdownValue(null, url_values['cost-value'], url_values['cost-label'], 'cost');
    }

    let terms = {};
    Object.keys(url_values).forEach(elem => {
      if (elem.startsWith('term-')) {
        const tax = elem.replace('term-', '');
        const tax_terms = url_values[elem].split(',');
        terms[tax] = tax_terms;
      }
    });

    if (!$.isEmptyObject(terms)) {
      sessionStorage.setItem('terms', JSON.stringify(terms));
    }

    checkStoredValues();
  }

  function getStoredValues() {
    const data = {
      'effort': sessionStorage.getItem('effort'),
      'cost': sessionStorage.getItem('cost'),
      'paged': sessionStorage.getItem('paged'),
      'terms': sessionStorage.getItem('terms'),
    }

    return data;
  }

  function checkStoredValues() {
    const stored_values = getStoredValues();

    if (stored_values.paged) {
      setPaged(stored_values.paged);
    }

    if (stored_values.effort) {
      const effort = JSON.parse(stored_values.effort);
      setDropdownValue(effort.label, effort.value, 'effort');
    }

    if (stored_values.cost) {
      const cost = JSON.parse(stored_values.cost);
      setDropdownValue(cost.label, cost.value, 'cost');
    }

    if (stored_values.terms) {
      const stored_terms = JSON.parse(stored_values.terms);
      setTermsValues(stored_terms);
    }

    getPosts(true);
  }

  function changeURL() {
    const stored_values = getStoredValues();
    const query_params = new URLSearchParams(window.location.search);

    const effort = JSON.parse(stored_values.effort);
    if (effort != null && effort.value !== '') {
      query_params.set('effort-label', effort.label);
      query_params.set('effort-value', effort.value);
    } else {
      query_params.delete('effort-label');
      query_params.delete('effort-value');
    }

    const cost = JSON.parse(stored_values.cost);
    if (cost != null && cost.value !== '') {
      query_params.set('cost-label', cost.label);
      query_params.set('cost-value', cost.value);
    } else {
      query_params.delete('cost-label');
      query_params.delete('cost-value');
    }

    if (stored_values.paged) {
      query_params.set('paged', stored_values.paged);
    } else {
      query_params.delete('paged');
    }

    if (stored_values.terms) {
      const terms = JSON.parse(stored_values.terms);
      $.each(terms, function (index, value) {
        query_params.set('term-' + index, value);
      });
    }

    history.replaceState(null, null, '?' + query_params.toString());
  }

  function getCheckedValues(taxonomy, group) {
    const containerSel = `div[data-taxonomy="${taxonomy}"]`;
    const selector = `${containerSel} ${group}`;
    const $inputs = $(selector);
    const $checked = $inputs.filter(':checked');
  
    let values = $checked.map(function () {
      return String($(this).val());
    }).get();
  
    const taxEntry = taxonomies_slugs.find(tax => tax[0] === taxonomy);
    if (taxEntry) {
      const direction = taxEntry[1];
      const orderRaw = taxEntry[2] || [];
      const order = orderRaw.map(id => String(id));
  
      if (order.length) {
        if (direction === 'above') {
          const last = order[order.length - 1];
          if (values.includes(last)) {
            order.forEach(id => {
              $inputs.filter(`[value="${id}"]`).prop('checked', true);
            });
            values = [...order];
          }
  
          order.forEach((id, idx) => {
            const $input = $inputs.filter(`[value="${id}"]`);
            if (!$input.is(':checked')) {
              const below = order.slice(idx + 1);
              const hasBelowChecked = below.some(bid => values.includes(bid));
              if (hasBelowChecked) {
                $input.prop('checked', true);
                values.push(id);
              }
            }
          });
        }
  
        if (direction === 'below') {
          const first = order[0];
          if (values.includes(first)) {
            order.forEach(id => {
              $inputs.filter(`[value="${id}"]`).prop('checked', true);
            });
            values = [...order];
          }
  
          order.forEach((id, idx) => {
            const $input = $inputs.filter(`[value="${id}"]`);
            if (!$input.is(':checked')) {
              const above = order.slice(0, idx);
              const hasAboveChecked = above.some(aid => values.includes(aid));
              if (hasAboveChecked) {
                $input.prop('checked', true);
                values.push(id);
              }
            }
          });
        }
      }
    }
  
    return values;
  }

  function getCheckedValuesFinal(taxonomy, group) {
    let values = [];
    $.each($('div[data-taxonomy="' + taxonomy + '"] ' + group + ':checked'), function () {
      if ($(this).data('all') == 0) {
        values.push($(this).val());
      }
    });

    return values;
  }

  function storeTerms() {
    const taxonomies = getTaxonomies();
    let terms = {};
    $.each(taxonomies, function (key, value) {
      terms[value] = getCheckedValues(value, '.term-input');
    });

    sessionStorage.setItem('terms', JSON.stringify(terms));
  }

  function getPosts() {
    let data = {
      action: 'get_posts',
      nonce: fpm001_localize.nonce,
      effort: getDropDownValue('effort'),
      cost: getDropDownValue('cost'),
      post_type: fpm001_ajax_list.post_type,
      page_id: fpm001_localize.page_id,
      post_taxonomy: fpm001_ajax_list.post_taxonomy,
      paged: paged,
      terms: getTerms(),
      posts_per_page: fpm001_ajax_list.posts_per_page,
    };

    ajax_posts.html('');
    ajax_error.html('');
    container.removeClass('change-bg-color');
    ajax_nav_bottom.removeClass('hidden');

    $.ajax({
      url: fpm001_localize.rest_url + 'posts',
      type: 'GET',
      dataType: 'json',
      data,
      success: (response) => {
        ajax_posts.html(response.html_posts);

        const count = response.count === undefined ? 0 : response.count;
        if (fpm001_ajax_list.post_type == 'higher-standard') {
          ajax_counter.html(count + ' of ' + response.total + ' Standards Remain');
        } else {
          ajax_counter.html(count + ' of ' + response.total + ' Strategies Remain');
        }

        const paginate = response.html_paginate !== undefined
          ? response.html_paginate
          : '';

        ajax_paginate.html(paginate);
        populateComparePosts();
      },
      error: (response) => {
        container.addClass('change-bg-color');
        ajax_nav_bottom.addClass('hidden');
        ajax_error.html(response.responseJSON.html_posts);
      },
    });
  }

  function scrollToTop() {
    window.scroll({
      top: ajax_nav_bottom.offset().top,
      left: 0,
      behavior: 'smooth',
    });
  }

  function storeDropdownValue(element = null, value = null, label = null, dropdown = null) {
    const data = {
      value: element ? element.data('value') : value,
      label: element ? element.text() : label,
    }
    const dropdown_label = element ? getDropDownLabel(element) : dropdown;

    sessionStorage.setItem('' + dropdown_label, JSON.stringify(data));
  }

  function setDropdownValue(label, value, dropdown) {
    $('#' + dropdown_prefix + dropdown)
      .attr('data-selected-label', label)
      .attr('data-selected-value', value)
      .text(label);
  }

  function getDropDownValue(dropdown_label) {
    const value = $('#' + dropdown_prefix + dropdown_label).attr('data-selected-value');
    return value;
  }

  function getDropDownLabel(element) {
    const id = element.parent().prev($('.btn-dropdown')).attr('id');
    const label = id.substring(dropdown_prefix.length);

    return label;
  }

  function storePaged(new_paged) {
    sessionStorage.setItem('paged', new_paged);
  }

  function setPaged(new_paged) {
    paged = new_paged;
  }

  function clearStorage() {
    sessionStorage.removeItem('effort');
    sessionStorage.removeItem('cost');
    sessionStorage.removeItem('paged');
    sessionStorage.removeItem('terms');
  }

  function getTerms() {
    const taxonomies = getTaxonomies();
    let terms = {};
    $.each(taxonomies, function (key, value) {
      terms[value] = getCheckedValuesFinal(value, '.term-input');
    });

    return terms;
  }

  function getTaxonomies() {
    const taxonomies = [];
    $('.terms-list').each(function () {
      const taxonomy = $(this).data('taxonomy');
      taxonomies.push(taxonomy);
    });

    return taxonomies;
  }

  function setTermsValues(stored_terms) {
    $.each(stored_terms, function (key, value) {
      const terms = value;
      $.each(terms, function (index, id) {
        $('#' + key + '-' + id).prop('checked', true);
      });
    });
  }

  function getCompare() {
    if (sessionStorage.getItem('post_type') !== fpm001_ajax_list.post_type) {
      sessionStorage.removeItem('compare');
    }

    const data = sessionStorage.getItem('compare');

    return data === null ? [] : JSON.parse(data);
  }

  function updateCompareList(value) {
    let compare = getCompare();
    if (compare.includes(value)) {
      const index = compare.indexOf(value);
      compare.splice(index, 1);
    } else {
      compare.push(value);
    }

    sessionStorage.setItem('compare', JSON.stringify(compare));

    showCompareButton();
  }

  function populateComparePosts() {
    const compare = getCompare();
    if (compare.length) {
      $.each(compare, function (index, value) {
        $('#compare-' + value).prop('checked', true);
      });
    }

    showCompareButton();
  }

  function showCompareButton() {
    sessionStorage.setItem('post_type', fpm001_ajax_list.post_type);
    if (sessionStorage.getItem('post_type') !== fpm001_ajax_list.post_type) {
      sessionStorage.removeItem('compare');
    }

    const compare = getCompare();
    if (compare.length >= 2) {
      compare_button.addClass('active');
      clear_compare_button.addClass('active');
    } else {
      compare_button.removeClass('active');
      clear_compare_button.removeClass('active');
    }
  }
}

export { initAjaxList }



// WEBPACK FOOTER //
// ./scripts/modules/ajax-list.js